import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import NewUserForm from "./NewUserForm";
import {
  useCreateUserMutation,
  useUpdateUserMutation,
} from "src/features/users/usersApiSlice";
import { useDispatch } from "react-redux";
import { setDialog } from "src/features/dialog/dialogSlice";
import Iconify from "src/components/iconify";

function UserDialog({ onClose, dialog }) {
  const [createUser] = useCreateUserMutation();
  const [updateUser] = useUpdateUserMutation();
  const dispatch = useDispatch();

  const handleCreateNewUser = async (data) => {
    try {
      const userData = await createUser(data).unwrap();
      console.log("userData :>> ", userData);
      if (userData && userData.status === "SUCCESS") {
        dispatch(
          setDialog({
            title: "Neuer Benutzer wurde erfolgreich erstellt!",
            type: "SUCCESS",
            data: {
              successText: userData.message,
            },
          })
        );
      }
    } catch (error) {
      console.log("error :>> ", error);
      if (error.data.message) {
        console.error("error :>> ", error.data.message);
        return window.alert(error.data.message);
      }
      return;
    }
  };

  const handleUserUpdate = async (data) => {
    // console.log("data :>> ", data);
    // return;
    try {
      const updatedData = { ...data, id: data._id };
      delete updatedData._id;
      console.log("updatedData :>> ", updatedData);
      const userData = await updateUser(updatedData).unwrap();
      console.log("userData :>> ", userData);
      if (userData) {
        console.log("data", data);
        dispatch(
          setDialog({
            title: "Benutzer wurde erfolgreich aktualisiert!",
            type: "SUCCESS",
            data: {
              successText: "Benutzer wurde erfolgreich aktualisiert!",
            },
          })
        );
      }
    } catch (error) {
      console.log("error :>> ", error);
      if (error.data.message) {
        console.error("error :>> ", error.data.message);
        return window.alert(error.data.message);
      }
      return;
    }
  };

  const onSubmit = async (data) => {
    if (dialog?.type === "CREATE") {
      await handleCreateNewUser(data);
    } else {
      await handleUserUpdate(data);
    }
  };

  return (
    <Dialog
      open
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={onClose}
    >
      <DialogTitle sx={{ pb: 0 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
        >
          <Box>
            <Typography variant="h4">
              {dialog?.title ?? "Benutzer"}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {dialog?.type === "CREATE"
                ? "Lege einen neuen Benutzer an und weise Rollen sowie Standorte zu."
                : "Passe Benutzerinformationen, Rollen und Standorte an."}
            </Typography>
          </Box>
          <IconButton aria-label="Schließen" onClick={onClose}>
            <Iconify icon="mingcute:close-line" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <NewUserForm
          initialValues={dialog?.data ?? ""}
          onSubmit={onSubmit}
          dialogType={dialog?.type}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Abbrechen
        </Button>
        <Button
          form="user-form"
          type="submit"
          color="secondary"
          variant="contained"
          autoFocus
        >
          {dialog?.type === "CREATE" ? "Erstellen" : "Speichern"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

UserDialog.propTypes = {};

export default UserDialog;
